module.exports = __webpack_public_path__ + "static/media/p20-tip-box-open.73a99a75.svg";